var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30078 1C4.30078 0.723858 4.07692 0.5 3.80078 0.5C3.52464 0.5 3.30078 0.723858 3.30078 1L4.30078 1ZM3.44723 13.3536C3.64249 13.5488 3.95907 13.5488 4.15433 13.3536L7.33631 10.1716C7.53158 9.97631 7.53158 9.65973 7.33631 9.46447C7.14105 9.2692 6.82447 9.2692 6.62921 9.46447L3.80078 12.2929L0.972354 9.46447C0.777092 9.2692 0.460509 9.2692 0.265247 9.46447C0.0699848 9.65973 0.0699848 9.97631 0.265247 10.1716L3.44723 13.3536ZM3.30078 1L3.30078 13L4.30078 13L4.30078 1L3.30078 1Z",
    fill: "#B63FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.3cdf891671d5b1f1386fb1c578f6fa3b.svg";
export { ForwardRef as ReactComponent };